module.exports = __webpack_public_path__ + "img/fb-icon.3ae80071.svg";